import App from '@/App';
import AdminLayout from '@/components/admin/AdminLayout';
import AuthGuard from '@/components/admin/AuthGuard';
import { AuthProvider } from '@/contexts/auth';

// Wrap the entire application with AuthProvider
export const AppWithAuth = () => (
  <AuthProvider>
    <App />
  </AuthProvider>
);

// Wrap admin layout with AuthGuard
export const ProtectedAdminLayout = () => (
  <AuthGuard>
    <AdminLayout />
  </AuthGuard>
);
